module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/layouts/tooltips/tooltips.component.html
// module id = ./src/app/theme/layouts/tooltips/tooltips.component.html
// module chunks = main